import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/new-fire-score-logo.png';
import { motion } from 'framer-motion';
import getVersion from '../utils/version';

const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const [version, setVersion] = useState<string>('');
  
  useEffect(() => {
    // Generate version number on component mount
    setVersion(`v${getVersion()}`);
  }, []);

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <div className="w-64 bg-gray-800 text-white h-full flex flex-col">
      <div className="flex justify-center py-4 border-b border-gray-700">
        <div className="flex items-center space-x-3">
          <motion.img
            src={logo}
            alt="Logo"
            className="w-22 h-12 object-contain cursor-pointer"
            onClick={handleLogoClick}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          />
        </div>
      </div>
      <div className="flex-1 overflow-y-auto">
        <ul className="space-y-2 p-4">
          <li>
            <Link 
              to="/" 
              className="flex items-center space-x-2 p-2 rounded hover:bg-gray-700"
            >
              <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
              <span>Dashboard</span>
            </Link>
          </li>
          <li>
            <Link 
              to="/games" 
              className="flex items-center space-x-2 p-2 rounded hover:bg-gray-700"
            >
              <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
              <span>Games</span>
            </Link>
          </li>
          <li>
            <Link 
              to="/settings" 
              className="flex items-center space-x-2 p-2 rounded hover:bg-gray-700"
            >
              <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <span>Settings</span>
            </Link>
          </li>
        </ul>
      </div>
      <div className="py-2 px-4 border-t border-gray-700 text-center">
        <div className="text-xs text-gray-400 font-light tracking-wider opacity-80">
          {version}
        </div>
      </div>
    </div>
  );
};

export default Sidebar; 